Instructors:
<table class="table my-2" style="border-bottom:1px solid #dee2e6">
  <tbody>
  <tr *ngFor="let instructor of instructors; index as iIdx">
    <th scope="row">{{ instructor.first_name }} {{ instructor.last_name }}</th>
    <td *ngIf="useIsSub">
      <input class="form-check-input" type="checkbox" id="isSub{{ id }}{{ iIdx }}"
             [(ngModel)]="instructor.is_sub">
      <label class="form-check-label" for="isSub{{ id }}{{ iIdx }}">Is sub?</label>
    </td>
    <td>
      <a href="#" class="px-1"
         [class.text-muted]="iIdx === 0"
         (click)="moveInstructorUp(iIdx);$event.preventDefault();">
        &uarr;
      </a>
      <a href="#" class="px-1"
         [class.text-muted]="iIdx === (instructors.length - 1)"
         (click)="moveInstructorDown(iIdx);$event.preventDefault();">
        &darr;
      </a>
    </td>
    <td class="text-right">
      <span class="text-danger cursor-pointer underline-on-hover" (click)="removeInstructor(iIdx)">Remove</span>
    </td>
  </tr>
  <tr *ngIf="instructors.length === 0">
    <td colspan="99" class="text-muted">
      None Selected
    </td>
  </tr>
  </tbody>
</table>
<div class="d-block clearfix mt-1">
  <button class="btn btn-primary btn-sm" type="button"
          (click)="openAddInstructor()">
    Add Instructor
  </button>
</div>
